export default __webpack_public_path__ + "static/2019_10-d9f380a3face7eb86e3f330ab295ca6a.png";